<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Components
	import Helmet from '@/Components/Helmet.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import Logo from '@/Components/Logo.svelte';
	// Stores
	import AuthUserStore from '@/Stores/AuthUserStore.js';
	// Constants
	import config from '@/config';

	let sending = false;
	let formData = {
		code: ''
	};

	$: errors = null;

	function handleSubmit() {
		sending = true;
		AuthUserStore.challenge(formData)
			.then(() => {
				navigate('/');
			})
			.catch((error) => {
				errors = error;
			})
			.finally(() => (sending = false));
	}
</script>

<Helmet title="Two Factor Challenge" />

<div class="flex items-center justify-center min-h-screen p-6 bg-brand-black">
	<div class="w-full max-w-md">
		{#if config.BRAND == 'socialbet'}
			<img
				src="/images/logo.png"
				class="block max-w-xs mx-auto h-10"
				alt={config.BRAND_NAME}
				height="32px"
				width="126px"
			/>
		{:else}
			<div class="w-auto h-20 mx-auto block px-16">
				<Logo />
			</div>
		{/if}

		<form class="mt-8 overflow-hidden bg-white rounded-lg shadow-xl" on:submit|preventDefault={handleSubmit}>
			<div class="px-10 pt-12 pb-4">
				<h1 class="text-3xl font-bold">Two-factor Challenge!</h1>
				<div class="w-24 mx-auto mt-6 border-b-2" />
				<p class="mt-3 font-light">
					Please confirm access to your account by entering the authentication code provided by your 2nd factor.
				</p>

				<!-- svelte-ignore a11y-autofocus -->
				<TextInput
					autofocus
					bind:value={formData.code}
					className="mt-10"
					label="Two factor code"
					name="code"
					type="text"
				/>
			</div>
			{#if errors && errors.error}
				{#each errors.error as error}
					<div class="mb-3 text-center form-error">{error}</div>
				{/each}
			{/if}
			<div class="flex items-center justify-between px-10 py-4 bg-gray-100 border-t border-gray-200">
				<LoadingButton
					className="px-6 py-3 rounded bg-secondary text-white text-sm font-bold
          whitespace-nowrap hover:bg-dark mx-auto"
					loading={sending}
					type="submit"
				>
					Login
				</LoadingButton>
			</div>
		</form>
	</div>
</div>
